<div class="surface-elevated radius-big p-tiny d-flex flex-column align-items-center gap-big">
  <common-ui-components-list-categories-header [config]="header()"></common-ui-components-list-categories-header>
  <div class="d-flex flex-column justify-content-center align-items-center w-100 px-plus">
    @for (section of services(); track section.title) {
      <common-ui-components-item-overview [item]="section"></common-ui-components-item-overview>
    }
  </div>
</div>
